import React from 'react';

const STYLES = {
  annuel: { label: 'Annuelle', cls: 'bg-sky-100 text-sky-800 border-sky-200' },
  nominative: { label: 'Nominative', cls: 'bg-emerald-100 text-emerald-800 border-emerald-200' },
  archos: { label: 'ARCHOS', cls: 'bg-violet-100 text-violet-800 border-violet-200' },
  avenant: { label: 'Avenant', cls: 'bg-amber-100 text-amber-800 border-amber-200' },
};

export const codeDispositif = (s = {}) => {
  if (s.dispositif_code) return s.dispositif_code;
  if (s.type_document === 'avenant' || s.is_avenant || s.contrat_parent_id) return 'avenant';
  if (['nominative', 'nominatif', 'par_periode'].includes(String(s.type_souscription || '').toLowerCase())) return 'nominative';
  const a = s.activites_selectionnees || {};
  if (a.pib?.length && !a.gros_oeuvre?.length && !a.second_oeuvre?.length && !a.travaux_publics?.length) return 'archos';
  return s.type_souscription ? 'annuel' : null;
};

export const DispositifBadge = ({ code, testId }) => {
  const st = STYLES[code];
  if (!st) return null;
  return (
    <span className={`inline-flex items-center text-[11px] font-semibold px-2 py-0.5 rounded-full border ${st.cls}`} data-testid={testId || `dispositif-badge-${code}`}>
      {st.label}
    </span>
  );
};
